import './style.scss'
import React from 'react'
import Img from 'gatsby-image'
import Intro from '../../../animations/Intro'
import { useInView } from 'react-intersection-observer'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'

export default function ISPrograms(props) {
	const [io, ioInView] = useInView({ triggerOnce: true })

	const { mru_international_logo, mru_international_backdrop, zucca_mascot_image_1, program_links } = props

	return (
		<div ref={io} id="is-programs" className="master-wrap grid-12 c5 grid-12 padd padd-top-2 padd-bottom-2">
			<div style={{ zIndex: "-1" }} className='bg'>
				<Img fluid={mru_international_backdrop.localFile.childImageSharp.fluid}
					imgStyle={{ objectFit: 'cover' }}
					objectPosition='50% 50%'
					className='Hero Text'
					alt='Next Logo'
				/>
			</div>

			<div className='span-12 logo-with-copy'>
				<div className='flex flex-wrap-mobile limit' style={{ columnGap: "2em", alignItems: "center" }}>
					<div className='logo-img span-6 span-12-tablet '>
						<Intro visible={ioInView} in={{ fade: 500 }} delayIn={500} mounted={true} stay={true} className="full-width">
							<div className='aspect-ratio square'>
								<Img fluid={mru_international_logo.localFile.childImageSharp.fluid}
									imgStyle={{ objectFit: 'cover' }}
									objectPosition='50% 50%'
									className='Hero Text'
									alt='Next Logo'
								/>
							</div>
						</Intro>
					</div>
					<Intro visible={ioInView} in={{ fade: 500 }} delayIn={650} mounted={true} stay={true} className="span-6 span-12-tablet">
						<div className='content ' >
							<p>
								The Office of International Services is here to guide each of you through the process of studying in the United States. Our Team will assist you with the wide range of essential and practical steps you will need as you transition to our university. All of us at MRU are committed to treating all of our students with respect and compassion as we all learn from one another.
							</p>

						</div>
					</Intro></div>
			</div>

			<div className="span-12  padd-top-2">
				<div className='right-bg padd'>
					<div className='intro outline flex flex-wrap-mobile' style={{ columnGap: "2em" }}>
						<Intro visible={ioInView} in={{ fade: 500 }} delayIn={500} mounted={true} stay={true} className="">
							<h1>Our
								International<br />
								Programs
							</h1>

						</Intro>
						<div className='limit-zucca' >
							<div style={{ paddingBottom: "73%" }} className='aspect-ratio zucca'>
								<Img fluid={zucca_mascot_image_1.localFile.childImageSharp.fluid}
									imgStyle={{ objectFit: 'cover' }}
									objectPosition='50% 50%'
									className='Hero Text'
									alt='Next Logo'
								/>
							</div>
						</div>
					</div>

					{
						program_links && program_links.length > 0 && (
							<div className="programs-two-columns" style={{ display: 'flex', marginTop: "2rem" }}>
								<div className="programs-column-left" style={{ flex: '1' }}>
									{program_links.slice(0, Math.ceil(program_links.length / 2)).map((item, i) => {
										return (
											<Intro key={i} visible={ioInView} in={{ fadeLeft: 500 }} delayIn={750 + 75 * i} mounted={true} stay={true} className="">
												<div className='single-school padd padd-left-off'>
													<div className='img'>
														{item?.image &&
															<div className='aspect-ratio'>
																<Img fluid={item.image.localFile.childImageSharp.fluid}
																	imgStyle={{ objectFit: 'cover' }}
																	objectPosition='50% 50%'
																	className='Hero Text'
																	alt='School of Education'
																/>
															</div>
														}
													</div>
													<div className='content padd padd-top-off'>
														<Link to={`/archives/academic/${item?.program?.post_name}`} className='single-school-link'>

															<h4 style={{ maxWidth: "22rem" }}>{item?.program?.post_title}</h4>
														</Link>
														<div className="links-container fs-85">
															<a href={item?.link} target='_blank' rel='noopener noreferrer'>
																<span className='button'>LEARN MORE
																	<span className="btn-arrow">
																		<FontAwesomeIcon icon={faFilePdf} />
																	</span>
																</span>
															</a>
														</div>
													</div>
												</div>
											</Intro>
										)
									})}
								</div>
								<div className="programs-column-right" style={{ flex: '1' }}>
									{program_links.slice(Math.ceil(program_links.length / 2)).map((item, i) => {
										return (
											<Intro key={i + Math.ceil(program_links.length / 2)} visible={ioInView} in={{ fadeLeft: 500 }} delayIn={750 + 75 * (i + Math.ceil(program_links.length / 2))} mounted={true} stay={true} className="">
												<div className='single-school padd padd-left-off'>
													<div className='img'>
														{item?.image &&
															<div className='aspect-ratio'>
																<Img fluid={item.image.localFile.childImageSharp.fluid}
																	imgStyle={{ objectFit: 'cover' }}
																	objectPosition='50% 50%'
																	className='Hero Text'
																	alt='School of Education'
																/>
															</div>
														}
													</div>
													<div className='content padd padd-top-off'>
														<Link to={`/archives/academic/${item?.program?.post_name}`} className='single-school-link'>

															<h4 style={{ maxWidth: "22rem" }}>{item?.program?.post_title}</h4>

														</Link>
														<div className="links-container fs-85">
															<a href={item?.link} target='_blank' rel='noopener noreferrer'>
																<span className='button'>LEARN MORE
																	<span className="btn-arrow">
																		<FontAwesomeIcon icon={faFilePdf} />
																	</span>
																</span>
															</a>
														</div>
													</div>
												</div>
											</Intro>
										)
									})}
								</div>
							</div>
						)
					}

				</div>
			</div>
		</div>
	)
}